/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantTotalLocalCashRedeemedRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetMerchantTotalLocalCashRedeemedResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getMerchantTotalLocalCashRedeemed = (request: GetMerchantTotalLocalCashRedeemedRequest, options?: CashRequestOptions) => post<GetMerchantTotalLocalCashRedeemedRequest, GetMerchantTotalLocalCashRedeemedResponse>("/2.0/cash/get-merchant-total-local-cash-redeemed", request, {...options, rejectOnError: true })